import ACTIONS from "../actions/types";
import moment from "moment";
import { has } from "lodash";
// The initial state is an immutable List/Array
const initialState = {
  page: 0,
  total: 0,
  perPage: 0,
  lastPage: 0,
  data: [],
  devices: [],
  lifecycles: [],
  devicesList: [],
  devicesTypes: [],
  devicesModels: [],
  organizations: [],
  selectedDevices: [],
  devicesTypesList: [],
  deviceTypeCategories: [],
  deviceOwnersList: [],
  devicesModelsList: [],
  deviceContractsList: [],
  isNoDeviceSelected: false,
  isFetchingDeviceData: true,
  isCalculatingElevation: true,
  isFetchingDevicesList: false,
  showCustomDateSelector: false,
  isElevationToggleVisible: false,
  isFetchingModelsDeviceData: false,
  isFetchingDeviceContractsList: true,
  // selectedDevice: {},
  selectedDeviceInfo: {},
  selectedDeviceAlarms: [],
  selectedDeviceServices: [],
  selectedDeviceLiveData: [],
  selectedDeviceTypeCategories: [],
  errorMessage: "",
  selectedStartDate: moment().subtract(1, "days").unix(),
  selectedEndDate: moment().unix(),

  isFetchingDeviceImages: true,
  deviceImagesList: [],
};

const devicesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.DEVICES.FETCH_ALL_DEVICES_LIST_START:
      return Object.assign({}, state, {
        isFetchingDevices: true,
        isFetchingDeviceData: true,
        isNoDeviceSelected: true,
        isFetchingDevicesList: true,
      });
    case ACTIONS.DEVICES.FETCH_ALL_DEVICES_WITH_NO_PAGINATION:
      return Object.assign({}, state, {
        devices: payload.devices,
      });
    case ACTIONS.DEVICES.FETCH_ALL_DEVICES_LIST_SUCCESS:
      return Object.assign({}, state, {
        page: payload.page,
        total: payload.total,
        perPage: payload.perPage,
        lastPage: payload.lastPage,
        devices: payload.devices,
        devicesList: payload.devices,
        selectedDevices: [],
        isFetchingDeviceData: false,
        isFetchingDevicesList: false,
      });

    case ACTIONS.DEVICES.FETCH_ALL_DEVICES_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetchingDevicesList: false,
        isFetchingDeviceData: false,
        errorMessage: payload,
      });

    case ACTIONS.DEVICES.SET_DEVICETYPE_CATEGORIES:
      return Object.assign({}, state, {
        deviceTypeCategories: payload,
      });

    case ACTIONS.DEVICES.SET_SELECTED_DEVICETYPE_CATEGORIES:
      return Object.assign({}, state, {
        selectedDeviceTypeCategories: payload,
      });

    case ACTIONS.DEVICES.UI.SWITCH_ELEVATION_TOGGLE:
      return Object.assign({}, state, {
        isElevationToggleVisible: payload,
        isCalculatingElevation: payload,
      });

    case ACTIONS.DEVICES.RESET_CALCULATION_START:
      let tempSelectedDevices = [...state.selectedDevices];
      tempSelectedDevices.forEach((device) => {
        if (has(device, "properties.elevation")) {
          let waterLevelIndex = device.device_model.data_model.findIndex(
            (model) => model.unit.name.toLowerCase() === "vandstand"
          );
          if (waterLevelIndex > -1) {
            device.device_model.data_model[waterLevelIndex].unit.value = "cm";
          }
        }
      });
      return Object.assign({}, state, {
        selectedDevices: [...tempSelectedDevices],
      });

    case ACTIONS.DEVICES.FETCH_SELECTED_DEVICES_LIST_START:
      return Object.assign({}, state, {
        ...state,
        isFetchingDeviceData: true,
      });
    case ACTIONS.DEVICES.FETCH_SELECTED_DEVICES_LIST_SUCCESS:
      return Object.assign({}, state, {
        ...state,
        data: payload.data,
        isFetchingDeviceData: false,
        isFetchingDevicesList: false,
        selectedDevices: payload.selectedDevices,
        // selectedDevices: [],
        selectedStartDate: payload.selectedStartDate,
        selectedEndDate: payload.selectedEndDate,
        isNoDeviceSelected: false,
      });
    case ACTIONS.DEVICES.FETCH_SELECTED_DEVICES_LIST_FAILURE:
      return Object.assign({}, state, {
        ...state,
        isFetchingDeviceData: false,
        isFetchingDevicesList: false,
        errorMessage: payload,
      });
    case ACTIONS.DEVICES.UI.SWITCH_CUSTOM_RANGE:
      return Object.assign({}, state, {
        ...state,
        showCustomDateSelector: payload,
      });

    case ACTIONS.DEVICES.CALCULATE_ELEVATION_START:
      return {
        ...state,
        isFetchingDeviceData: true,
      };
    case ACTIONS.DEVICES.CALCULATE_ELEVATION_SUCCESS:
      return {
        ...state,
        data: [...payload.data],
        isCalculatingElevation: payload.isCalculatingElevation,
        isFetchingDeviceData: false,
      };
    case ACTIONS.DEVICES.CALCULATE_ELEVATION_FAILURE:
      return {
        ...state,
        isFetchingDeviceData: false,
        isCalculatingElevation: true,
        errorMessage: payload,
      };

    case ACTIONS.DEVICES.FETCH_ALL_MODELS_LIST_START:
      return {
        ...state,
        isFetchingModelsDeviceData: true,
      };
    case ACTIONS.DEVICES.FETCH_ALL_MODELS_LIST_SUCCESS:
      return {
        ...state,
        isFetchingModelsDeviceData: false,
        devicesModels: payload,
        devicesModelsList: payload,
      };
    case ACTIONS.DEVICES.SET_SELECTED_MODELS_LIST_SUCCESS:
      return {
        ...state,
        isFetchingModelsDeviceData: false,
        devicesModelsList: payload,
      };

    case ACTIONS.DEVICES.SET_SELECTED_MODELS_LIST_FAILURE:
      return {
        ...state,
        isFetchingModelsDeviceData: false,
        errorMessage: payload,
      };
    case ACTIONS.DEVICES.FETCH_ALL_MODELS_LIST_FAILURE:
      return {
        ...state,
        isFetchingModelsDeviceData: false,
        errorMessage: payload,
      };

    case ACTIONS.DEVICES.FETCH_ALL_TYPES_LIST_START:
      return {
        ...state,
        isFetchingModelsDeviceData: true,
      };

    case ACTIONS.DEVICES.SET_SELECTED_TYPES_LIST_START:
      return {
        ...state,
      };
    case ACTIONS.DEVICES.SET_SELECTED_TYPES_LIST_FAILURE:
      return {
        ...state,
        errorMessage: payload,
      };

    case ACTIONS.DEVICES.SET_DEVICES_LIST:
      return {
        ...state,
        isFetchingDeviceData: true,
        devicesList: payload,
      };
    case ACTIONS.DEVICES.SET_DEVICES_LIST_SUCCESS:
      return {
        ...state,
        isFetchingDeviceData: false,
      };
    case ACTIONS.DEVICES.CLEAR_FILTERS_START:
      return {
        ...state,
        isFetchingDeviceData: true,
        isFetchingDevicesList: true,
      };
    case ACTIONS.DEVICES.FILTERS_START:
      return {
        ...state,
        isFetchingDeviceData: true,
        isFetchingDevicesList: true,
      };
    case ACTIONS.DEVICES.SET_DEFAULT_FILTERS_LISTS:
      return {
        ...state,
        devicesList: [...payload.devicesList],
        deviceTypeCategories: [...payload.deviceTypeCategories],
        devicesModelsList: [...payload.devicesModelsList],
      };

    case ACTIONS.DEVICES.CLEAR_FILTERS_SUCCESS:
      return {
        ...state,
        isFetchingDeviceData: false,
        isFetchingDevicesList: false,
      };

    case ACTIONS.DEVICES.PREPEND_TO_SELECTED_DEVICES:
      return Object.assign({}, state, {
        // isFetchingDeviceData: true,

        selectedDevices: [...state.selectedDevices, payload],
        isNoDeviceSelected: false,
        devicesList: [],
      });
    case ACTIONS.DEVICES.SET_NO_DEVICE_SELECTED:
      return Object.assign({}, state, {
        selectedDevices: [],
        selectedDeviceInfo: {},
        selectedStartDate: moment().subtract(1, "days").unix(),
        selectedEndDate: moment().unix(),
        isNoDeviceSelected: true,
      });
    case ACTIONS.DEVICES.SELECTED_DEVICE_INFO:
      return Object.assign({}, state, {
        selectedDeviceInfo: { ...payload },
        selectedDevices: [{ ...payload }],
        selectedStartDate: moment().subtract(1, "days").unix(),
        selectedEndDate: moment().unix(),
        isNoDeviceSelected: true,
      });
    case ACTIONS.DEVICES.NO_SELECTED_DEVICE_INFO:
      return Object.assign({}, state, {
        selectedDeviceInfo: {},
        selectedDevices: [],
        selectedStartDate: moment().subtract(1, "days").unix(),
        selectedEndDate: moment().unix(),
        isNoDeviceSelected: true,
      });
    case ACTIONS.DEVICES.UPDATE_SELECTED_DEVICE_INFO:
      return Object.assign({}, state, {
        selectedDeviceInfo: { ...payload },
        selectedDevices: [{ ...payload }],
      });
    case ACTIONS.DEVICES.SET_DEVICES_LIFECYCLES:
      return Object.assign({}, state, {
        lifecycles: [...payload],
      });
    case ACTIONS.DEVICES.SELECTED_DEVICE_DELETED:
      return Object.assign({}, state, {
        selectedDeviceInfo: {},
        selectedDevices: [],
      });
    case ACTIONS.DEVICES.SET_DEVICE_CONTRACTS_LIST_START:
      return Object.assign({}, state, {
        isFetchingDeviceContractsList: true,
        deviceContractsList: [],
      });
    case ACTIONS.DEVICES.SET_DEVICE_CONTRACTS_LIST:
      return Object.assign({}, state, {
        isFetchingDeviceContractsList: false,
        deviceContractsList: [...payload.reverse()],
      });
    case ACTIONS.DEVICES.SET_DEVICE_CONTRACTS_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetchingDeviceContractsList: true,
        deviceContractsList: [],
      });

    case ACTIONS.DEVICES.REMOVE_DEVICE_FROM_CONTRACT_START:
      return Object.assign({}, state, {
        isFetchingDeviceContractsList: true,
        deviceContractsList: [],
      });
    case ACTIONS.DEVICES.REMOVE_DEVICE_FROM_CONTRACT:
      return Object.assign({}, state, {
        isFetchingDeviceContractsList: false,
        deviceContractsList: [...state.deviceContractsList.filter((d) => d._id !== payload._id).reverse()],
      });
    case ACTIONS.DEVICES.REMOVE_DEVICE_FROM_CONTRACT_FALURE:
      return Object.assign({}, state, {
        isFetchingDeviceContractsList: true,
        deviceContractsList: [],
      });

    case ACTIONS.DEVICES.SET_DEVICE_OWNERS:
      return Object.assign({}, state, {
        deviceOwnersList: [...payload],
      });

    case ACTIONS.DEVICES.FETCHING_DEVICE_IMAGES_START:
      return Object.assign({}, state, {
        isFetchingDeviceImages: true,
        // deviceImagesList: [],
      });
    case ACTIONS.DEVICES.FETCHING_DEVICE_IMAGES:
      return Object.assign({}, state, {
        isFetchingDeviceImages: false,
        deviceImagesList: [
          ...payload.map((pic) => ({
            original: pic.url,
            thumbnail: pic.url,
            ...pic,
          })),
        ],
      });
    case ACTIONS.DEVICES.REMOVE_DEVICE_IMAGE:
      return Object.assign({}, state, {
        isFetchingDeviceImages: false,
        deviceImagesList: state.deviceImagesList.filter((i) => i._id !== payload),
      });

    case ACTIONS.DEVICES.REMOVE_DEVICE_IMAGE_FAILURE:
      return Object.assign({}, state, {
        isFetchingDeviceImages: false,
      });

    case ACTIONS.DEVICES.FETCHING_DEVICE_IMAGES_FALURE:
      return Object.assign({}, state, {
        isFetchingDeviceImages: false,
      });

    case ACTIONS.DEVICES.UPLOAD_ALL_PICTURES_START:
      return Object.assign({}, state, {
        isFetchingDeviceImages: true,
      });
    case ACTIONS.DEVICES.UPLOAD_ALL_PICTURES:
      return Object.assign({}, state, {
        isFetchingDeviceImages: false,
        deviceImagesList: [...payload],
      });
    case ACTIONS.DEVICES.UPLOAD_ALL_PICTURES_FAILURE:
      return Object.assign({}, state, {
        isFetchingDeviceImages: false,
      });
    case ACTIONS.DEVICES.SET_SELECTED_DEVICE_INFO:
      return {
        ...state,
        selectedDeviceInfo: payload,
      };

    case ACTIONS.LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default devicesReducer;
